module.exports = __webpack_public_path__ + "img/z-other-witch_home.d61cf1e3.svg";